import React from 'react';
import Img from 'gatsby-image';
import { Box, Flex } from '@chakra-ui/react';
import { jsx as ___EmotionJSX } from "@emotion/react";
const Checkboard = _ref => {
  let {
    children,
    image
  } = _ref;
  return ___EmotionJSX(Flex, {
    flexWrap: "wrap"
  }, ___EmotionJSX(Box, {
    w: ['100%', '100%', '45%'],
    pl: [0, 6, 6]
  }, ___EmotionJSX(Img, {
    fluid: image.childImageSharp.fluid
  })), ___EmotionJSX(Box, {
    w: ['100%', '100%', '55%'],
    pt: [6, 0, 0],
    pr: 6,
    pb: 6,
    pl: 6
  }, children));
};
export default Checkboard;